import { useState } from 'react';
import { AdherenceLogEventType } from '../../../../api/events-client/events-client.type';

/**
 * Custom hook to manage adherence logs filters state
 *
 * @returns Object containing filter states and update functions
 */
const useAdherenceLogsFilters = () => {
  // Event type filters
  const [eventTypeFilters, setEventTypeFilters] = useState<string[]>([]);

  // Reset all filters to their default state
  const handleResetFilters = () => {
    // Set event type filters to include all available options
    setEventTypeFilters(Object.values(AdherenceLogEventType));
  };

  // Initialize filters with all values
  const initializeFilters = () => {
    // For initial load, you could set default filters here
    setEventTypeFilters(Object.values(AdherenceLogEventType));
  };

  // Get the selected event type for API calls
  // If exactly one type is selected, use it for filtering
  // If none or multiple are selected, return undefined to show all
  const getSelectedEventTypes = (): AdherenceLogEventType[] | undefined => {
    // Validate that each filter is a valid enum value
    const validFilters = eventTypeFilters.filter((type) =>
      Object.values(AdherenceLogEventType).includes(type as AdherenceLogEventType),
    );

    return validFilters.map((type) => type as AdherenceLogEventType);
  };

  return {
    // Filter states
    eventTypeFilters,
    setEventTypeFilters,

    // Utility functions
    handleResetFilters,
    initializeFilters,
    getSelectedEventTypes,
  };
};

export { useAdherenceLogsFilters };
